import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import 'moment/locale/de';
import moment from 'moment';
import { ThemeProvider as MUiThemeProvider } from '@mui/material/styles';
import { ThemeProvider } from 'styled-components';

import { SESSION_FILTER_KEY } from './constants';
import Pages from './pages';
import store from './store';

import { mainTheme, materialTheme } from './common/global-styles';
import HelmetComponent from 'components/helmet-component/helmet-component';

import { setUserLastSingIn } from '@/services/user-service';

import { queryClient } from '@/shared/api/query-client';
import { initializeAuth, AuthProvider } from '@/shared/lib/auth';
import type { InitializeConfiguration } from '@/shared/lib/auth';

import './index.scss';

moment.locale('de');

const root = createRoot(document.getElementById('root') as HTMLElement);

const initializeConfig: InitializeConfiguration = {
  onLoginSuccess: () => {
    sessionStorage.removeItem(SESSION_FILTER_KEY);

    try {
      setUserLastSingIn();
    } catch (e) {
      console.log(e);
    }
  }
};

initializeAuth(initializeConfig).then(() => {
  root.render(
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <MUiThemeProvider theme={materialTheme}>
          <ThemeProvider theme={mainTheme}>
            <Provider store={store}>
              <Router basename='/'>
                <HelmetComponent />
                <Pages />
              </Router>
            </Provider>
          </ThemeProvider>
        </MUiThemeProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
});
